module.exports = __webpack_public_path__ + "static/media/basic_concepts_icone36f4045.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/basic_concepts_icon.svg
// module id = 1316
// module chunks = 0